const name = 'BaseAttribute';
const properties = {};
function animate(kit, elements, duration = 0, delay = 0, params = {}) {
    return kit.engine.tween(elements, { duration, delay, ...params }, ['attr']);
}
export { name, properties, animate };
//# sourceMappingURL=baseAttribute.js.map